module.exports = "<app-book [BookName]=\"'php'\" [BookTitle]=\"bookTitle\" [BookId]=\"BookId\"></app-book>\r\n"